import { useMutation, useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, ProgressBar, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useRouteMatch } from "react-router";
import { useHistory } from "react-router-dom";
import {
  GET_PROJECT_SUPERVISOR,
  GET_TASK_SUPERVISOR,
} from "../../../graphql/queries";

import {
  CREATE_NOTE_SUPERVISOR,
  UPDATE_STATUS_PROJECT_RETURN_WORKER,
  UPDATE_STATUS_PROJECT_SUPERVISOR,
} from "../../../graphql/mutation";
import { matchProjectID } from "../../../redux/actions/spvAction";
import SEO from "../../SEO";
import Swal from "sweetalert2";

const TaskDetail = ({ createNewNote, matchProjectID, projectID }) => {
  let workerList = [];
  const match = useRouteMatch();
  const history = useHistory();

  console.log(match.params.id);

  const convertToDate = (inputDate) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    let date = new Date(+inputDate);
    return date.toLocaleDateString("id-ID", options);
  };

  useEffect(() => {
    matchProjectID(match.params.id);
    console.log(projectID);
  }, []);

  const formik = useFormik({
    initialValues: createNewNote,
    onSubmit: async (values) => {
      console.log(values);
      const returnToWorker = await updateStatusProjectReturnNoteWorker({
        variables: {
          ...values,
          id: parseInt(projectID),
        },
      });

      let timerInterval;
      const alertToUser = await Swal.fire({
        title: "Success!",
        text: "The project has been successfully returned to worker",
        timer: 3000,
        icon: "success",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          console.log("I was closed by the timer");
        }
      });

      const updateStatusWorker = await updateStatusProject({
        variables: { id: parseInt(projectID), status: "return to worker" },
      });
      const pushToTaskList = await history.push(
        "/dashboard/supervisor/task-list"
      );
      returnToWorker();
      alertToUser();
      updateStatusWorker();
      pushToTaskList();
    },
  });

  const {
    error: projectError,
    data: projectData,
    loading: projectLoading,
  } = useQuery(GET_PROJECT_SUPERVISOR, {
    pollInterval: 1000,
  }); // TODOS: GET TASK DETAIL

  const { error: taskError, data: taskData, loading: taskLoading } = useQuery(
    GET_TASK_SUPERVISOR,
    {
      pollInterval: 1000,
    }
  ); // TODOS: GET TASK DETAIL
  const [updateStatusProject] = useMutation(UPDATE_STATUS_PROJECT_SUPERVISOR);
  const [updateStatusProjectReturnNoteWorker] = useMutation(
    UPDATE_STATUS_PROJECT_RETURN_WORKER
  );

  const [returnWithNote] = useMutation(CREATE_NOTE_SUPERVISOR);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (projectLoading) return <LinearProgress />;
  if (projectError) return "Error...";

  if (taskLoading) return <LinearProgress />;
  if (taskError) return "Error...";

  const filterProjectData = projectData.findAllProjectSupervisor.filter(
    (item) => item.id == match.params.id
  );

  const filterTaskData = taskData.findAllTaskSupervisor.filter(
    (item) => item.project_id == match.params.id
  );

  console.log(filterTaskData);

  const isChecked = filterTaskData.filter(({ is_check }) => is_check == "true")
    .length;

  const getNotes = filterProjectData[0].notes.map(({ note }, key) => {
    console.log(note);
    return (
      <>
        <li className="list-group-item" key={key}>
          - {note}
        </li>
      </>
    );
  });

  filterProjectData[0].worker.map(({ fullname }) => {
    return workerList.push(fullname);
  });

  const modalNotes = filterProjectData.map(
    ({ id, title, description, status }) => {
      return (
        <>
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            key={id}
          >
            <Modal.Header closeButton>
              <Modal.Title className="text-center">
                <strong>Project Title: </strong> {title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <p className="font-weight-bold">Project ID: </p>
                <input
                  type="text"
                  placeholder={projectID}
                  name="project_id"
                  value={formik.values.project_id}
                  onChange={formik.handleChange}
                  style={{ width: "50px" }}
                  className="text-center mb-3"
                  disabled
                />
                <p className="font-weight-bold">Project Description: </p>
                <p>{description}</p>
                <p className="font-weight-bold">Notes for Worker: </p>
                <textarea
                  type="text"
                  name="note"
                  value={formik.values.note}
                  placeholder="Insert a new note here"
                  onChange={formik.handleChange}
                  style={{ width: "100%", resize: "none", height: "200px" }}
                />
                <div className="d-flex justify-content-end">
                  <Button
                    title="Close"
                    variant="secondary"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                  <Button className="ml-3" type="submit">
                    Submit
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </>
      );
    }
  );

  const getTaskDetail = filterTaskData
    .slice()
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map(({ id, task, is_check }, key) => {
      return (
        <div className="tasklist-progress my-3" key={key}>
          <p className="text-capitalize m-0">
            {key + 1}. {is_check == "true" ? <del>{task}</del> : task}
          </p>
        </div>
      );
    });
  const now = Math.floor((isChecked / filterTaskData.length) * 100);

  const progressInstance = (
    <ProgressBar
      animated
      now={now || 0}
      min={0}
      variant={now == 100 ? "success" : "primary"}
      label={`${now}%`}
    />
  );

  return (
    <div className="tasklist-section m-2 pb-5">
      <SEO
        title="Supervisor"
        description="Task List Detail"
        content="Task List Detail"
      />

      {modalNotes}
      <Button
        variant="primary"
        onClick={() => history.push("/dashboard/supervisor/task-list")}
      >
        Back
      </Button>
      <h1 className="text-center text-primary my-5">Detail Task</h1>
      <Row>
        <Col
          lg={10}
          md={10}
          sm={10}
          xs={10}
          className="mx-auto tasklist-progress"
        >
          <Row className="text-center d-flex justify-content-center align-items-center">
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Start Date</span>
                <br />
                <span className="font-weight-normal">
                  {convertToDate(filterProjectData[0].start_date)}
                </span>
              </div>
            </Col>
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Due Date</span>
                <br />
                <span className="font-weight-normal">
                  {convertToDate(filterProjectData[0].due_date)}{" "}
                </span>
              </div>
            </Col>
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Planner Name</span>
                <br />
                <span className="text-capitalize">
                  {filterProjectData[0].created_by.fullname}
                </span>
              </div>
            </Col>
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Worker Name</span>
                <br />
                <span className="text-capitalize">{workerList.join(", ")}</span>
              </div>
            </Col>
          </Row>
          <div className="my-3">
            <h3 className="font-weight-bold text-center my-5">
              {filterProjectData[0].title}
            </h3>
          </div>
          <div className="my-3">
            <p className="font-weight-bold">
              Project ID:{" "}
              <span className="font-weight-normal">{match.params.id}</span>
            </p>
          </div>

          <div className="my-3">
            <p className="font-weight-bold">Project Description</p>
            {filterProjectData[0].description}
          </div>
          <div className="my-3">
            <p className="font-weight-bold">File Attachment: </p>
            {filterProjectData[0].attachment ? (
              <a href={filterProjectData[0].attachment} download>
                Link Attachment
              </a>
            ) : (
              "None"
            )}
          </div>
          <div>
            <p className="font-weight-bold my-3">Task Progress:</p>
            {progressInstance}

            <p className="font-weight-bold my-3">
              Task List:{" "}
              <span
                className={`font-weight-normal${getTaskDetail ? "d-none" : ""}`}
              >
                None
              </span>
            </p>
            {getTaskDetail}
          </div>
          <ul className="list-group">
            <span>
              <strong>Notes: </strong>
              {!filterProjectData[0].notes[0] ? "None" : ""}
            </span>
            {filterProjectData[0].notes[0] ? getNotes : ""}
          </ul>
          <div className="d-flex justify-content-end my-3">
            {filterProjectData[0].status === "complete" ? (
              ""
            ) : (
              <>
                <Button
                  variant="warning"
                  onClick={handleShow}
                  className="mx-2 text-white"
                >
                  Return To Worker
                </Button>

                <Button
                  variant="primary"
                  className="mx-2"
                  onClick={() => {
                    const updateStatusComplete = async () =>
                      await updateStatusProject({
                        variables: {
                          id: parseInt(projectID),
                          status: "complete",
                        },
                      });
                    let timerInterval;
                    const alertToUser = async () =>
                      await Swal.fire({
                        title: "Success!",
                        text: "The project has been successfully completed",
                        timer: 3000,
                        icon: "success",
                        timerProgressBar: true,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                        willClose: () => {
                          clearInterval(timerInterval);
                        },
                      }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                          console.log("I was closed by the timer");
                        }
                      });
                    const pushToSupervisor = async () =>
                      await history.push("/dashboard/supervisor/task-list");
                    updateStatusComplete();
                    alertToUser();
                    pushToSupervisor();
                  }}
                >
                  Complete
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    createNewNote: state.spv.createNewNote,
    projectID: state.spv.matchProjectID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    matchProjectID: (projectID) => dispatch(matchProjectID(projectID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetail);
